import { BING_ADS_QUERY } from '../../GraphQL/Queries/commerce/BingAdsQuery';
import { graphQlRequest } from '../../GraphQL/RequestHandler';
import {
  BingAdsReqObject,
  IAdsData
} from '../../responseTypes/commerceResponse';

// import mock from './bingAdsMock.js';

export const getBingAds = async (reqObj: BingAdsReqObject) => {
  try {
    // const response: IAdsData = await graphQlRequest(BING_ADS_QUERY, {
    //   videoReferenceId: '65013bb43e866c66dcd676d1',
    //   timeStamp: '10'
    // });
    const response: IAdsData = await graphQlRequest(BING_ADS_QUERY, reqObj, '');
    return response?.getAds;
    // return mock;
  } catch (error) {
    console.error('Error while fetching Bing Ads: ', error);
  }
};
